import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes, Router } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { ListsComponent } from './components/lists/lists.component';
import { ListComponent } from './components/list/list.component';
import { ProjectsComponent } from './components/projects/projects.component';
import { ProjectComponent } from './components/project/project.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { ContactComponent } from './components/contact/contact.component';
import { NotesComponent } from './components/notes/notes.component';
import { DeletedComponent } from './components/deleted/deleted.component';
import { RoutineComponent } from './components/routine/routine.component';
import { WallComponent } from './components/wall/wall.component';
import { UserComponent } from './components/user/user.component';


const routes: Routes = [
  {path: '', component: LoginComponent},
  {path: 'home', component: HomeComponent},
  {path: 'lists', component: ListsComponent},
  {path: 'projects', component: ProjectsComponent},
  {path: 'contacts', component: ContactsComponent},
  {path: 'contact/:id', component: ContactComponent},
  {path: 'project/:id', component: ProjectComponent},
  {path: 'list/:id', component: ListComponent},
  {path: 'notes', component: NotesComponent},
  {path: 'routine', component: RoutineComponent},
  {path: 'deleted', component: DeletedComponent},
  {path: 'wall', component: WallComponent},
  {path: 'user', component: UserComponent}
];

@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(routes)
  ],
  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts